import { useHistory } from 'react-router-dom';

import { baseSegment } from './altenarRoutes';
import { ALTENAR_MAP_ROUTES, ALTENAR_PAGE_BY_ROUT } from './altenarRoutesConstants';

export const useAltenarRoutes = () => {
  const history = useHistory();
  const goTo = page => {
    const route = ALTENAR_MAP_ROUTES[page];
    route && history.push(route);
  };
  const goBack = () => history.goBack();
  const pushUrl = url => url && history.push(url);
  const replaceUrl = url => url && history.replace(url);
  const getPageByPath = path => ALTENAR_PAGE_BY_ROUT[baseSegment(path)];
  const setAltenarPage = path => {
    const route = getPageByPath(path);
    route && window.altenarWSDK?.set({ page: route });
  };
  return {
    getPageByPath,
    goBack,
    goTo,
    pushUrl,
    replaceUrl,
    setAltenarPage,
  };
};
